<template>
<div ref="container" class="focus-background" :class="{'focus-background-show':loaded}" :style="'background-image: url(' + src + ')'">
    <slot></slot>
</div>
</template>

<script>
export default {

    name: "FocusBackground",

    props: {
        src: {
            type: String,
            required: true,
            default: "",
        }
    },

	data(){
		return {
			loaded: false
		}
	},

    created(){
		var temp = this;
		this.load(this.src).then(function(){
			temp.loaded = true;
		}).catch(function(){
			temp.loaded = true;
		})
	},

    methods: {

        load(src) {
            return new Promise(function (resolve, reject) {
                const image = new Image();
                image.addEventListener('load', resolve);
                image.addEventListener('error', reject);
                image.src = src;
            });
        }

    }

}
</script>
